import { fetchData, API_TYPE, IResponse } from '@umu/umu-fetch';
import { handlePromiseError } from 'common/utils/errorHandler';

const API = {
    SWITCH_VERSION: {
        type: API_TYPE.POST,
        url: '/uapi/v1/enterprise/switch-version-type',
    },
};
export const setSwitchVersion = (versionType: string) => {
    return fetchData(
        API.SWITCH_VERSION,
        {
            version_type: versionType,
        },
        { silent: true },
    )
        .then((res: IResponse<Record<string, string>>) => {
            return res.error_code;
        })
        .catch((error: unknown) => {
            handlePromiseError(error, 'setSwitchVersion', 'setSwitchVersion fetchData error', { versionType });
        });
};
